export const API_URL = "https://backapi2021.jordanberti.com/api/"

export const CUSTOMERS_API = API_URL + "customers"
export const INVOICES_API = API_URL + "invoices"
export const USERS_API = API_URL + "users"
export const LOGIN_API = API_URL + "login_check"